import React from 'react';
import { Button, Flex } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import { jsx as _jsx } from "react/jsx-runtime";
const {
  t
} = I18N.ns('molten.dataViewers.dashboard.ToggleEditingAction');
export default {
  id: 'dashboard.ToggleEditingAction',
  matches: {
    client: ['molten.dataViewer.DashboardDataViewer'],
    use: 'actionBar'
  },
  handles: () => true,
  customComponent: ({
    context,
    action
  }) => {
    const {
      clientProps
    } = context;
    const {
      editing,
      onOkay,
      onSetEditing,
      value,
      dashboard
    } = clientProps;
    return /*#__PURE__*/_jsx(Flex, {
      variant: "rowM",
      children: !editing ? /*#__PURE__*/_jsx(Button, {
        variant: "link",
        onClick: onSetEditing,
        children: t('editLayout')
      }) : /*#__PURE__*/_jsx(Button, {
        variant: "primary",
        onClick: onOkay,
        disabled: value === dashboard,
        children: t('done')
      })
    });
  }
};